export class MapOption{
    map_options: string;

    constructor() {
        this.map_options = "all/download";
    }
}